import { useRegisterSupportOrganization } from "@/api/services/admin/rso";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { TopPage } from "@/components/elements/TopPage";
import { RegisterSupportOrganizationForm } from "@/features/rso/components/RegisterSupportOrganizationForm";
import { convertRsoResToForm } from "@/features/rso/utils/converts";
import { Stack } from "@mui/material";
import { FC } from "react";

type TRsoEditPageProps = {};

export const RsoEditPage: FC<TRsoEditPageProps> = () => {
  const { data: rsoResult, isLoading } = useRegisterSupportOrganization();
  const rsoData = rsoResult?.data;

  if (isLoading || !rsoData) return <LoadingPage />;

  return (
    <Stack gap={4}>
      <TopPage title="登録支援機関の編集" description="企業の基本情報を入力して追加しましょう" enablePageBack={false} />
      <RegisterSupportOrganizationForm previousData={convertRsoResToForm(rsoData)} />
    </Stack>
  );
};
